import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors } from '@angular/forms';

function phoneRequired(control: AbstractControl): ValidationErrors | null {
    const value = control.value as { contactNumber?: string } | null;
    return value?.contactNumber?.trim() ? null : { required: true };
}
import { DialogComponent } from '../../../@core/components/ui/dialog/dialog.component';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';
import { IconComponent } from '../../../@core/components/ui/icon/icon.component';
import { PhoneInputComponent, PhoneNumberValue } from '../phone-input/phone-input.component';
import { TextCasePipe } from '../../pipes/textCase.pipe';
import { UserService } from '../../../contract-management/services/user.service';
import { ToastService } from '../../../@core/services/toast.service';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { IUser } from 'src/app/@core/models/model';

@Component({
    selector: 'app-phone-number-dialog',
    standalone: true,
    imports: [
        DialogComponent,
        ButtonComponent,
        IconComponent,
        PhoneInputComponent,
        TextCasePipe,
        ReactiveFormsModule
    ],
    templateUrl: './phone-number-dialog.component.html',
    styleUrl: './phone-number-dialog.component.scss'
})
export class PhoneNumberDialogComponent {

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() phoneNumberSubmitted = new EventEmitter<void>();

    phoneForm: FormGroup;
    phoneNumberValue: PhoneNumberValue = {
        countryCode: '44',
        contactNumber: '',
        countryShortName: 'GB'
    };

    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        private toastService: ToastService,
        private authService: AuthenticationService
    ) {
        this.phoneForm = this.fb.group({
            phoneNumber: [this.phoneNumberValue, phoneRequired]
        });
    }

    onPhoneNumberChange(phoneValue: PhoneNumberValue) {
        this.phoneNumberValue = phoneValue;
    }

    submitPhoneNumber() {
        this.phoneForm.markAllAsTouched();
        if (this.phoneForm.invalid) {
            return;
        }

        const phoneValue = this.phoneForm.get('phoneNumber')?.value;

        const currentUser = this.authService.getUser();
        if (!currentUser?._id) {
            this.toastService.error('Unable to identify user. Please login again.');
            return;
        }

        this.closeDialog();

        const user: Partial<IUser> = {
            _id: currentUser._id,
            phoneNumber: {
                countryCode: phoneValue.countryCode,
                contactNumber: phoneValue.contactNumber,
                countryShortName: phoneValue.countryShortName
            }
        }

        this.userService.updateUser(user).subscribe((res: any) => {
            if (res.success) {
                this.toastService.success('Phone number updated successfully');
                this.authService.setUserData(res.data);
                this.phoneNumberSubmitted.emit();
            } else {
                this.toastService.error(res.message || 'Failed to update phone number');
            }
        });
    }

    closeDialog() {
        this.visible = false;
        this.visibleChange.emit(false);
        this.phoneNumberValue = {
            countryCode: '44',
            contactNumber: '',
            countryShortName: 'GB'
        };
        this.phoneForm.patchValue({ phoneNumber: this.phoneNumberValue });
        this.phoneForm.markAsUntouched();
        this.phoneForm.markAsPristine();
    }

    onHide() {
        this.closeDialog();
    }
}


